import React from 'react'

const Btn = ({ to, type, value }) => {
  return (
    <a href={to} className={`button ${type?type:""}`}>
      {value}
    </a>
  );
};

export default Btn